import { Service } from '../service.js';
import { env } from '../env.js';

class FormularioService extends Service {
  constructor(controleDeInstancia) {
    super(controleDeInstancia);

    this.url = env.url + 'formulario';

    this.controladoresDeInstancia = {
      listar: new AbortController(),
      editar: new AbortController(),
      confirmar: new AbortController()
    };
  }

  async getDadosPelaKey(objetoDeFiltros, controlador) {
    this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    const url = `${this.url}/buscar-formulario${queryString}`;
    return super.get(url, this.controladoresDeInstancia.listar);
  }

  async getDadosPeloId(id, controlador) {
    this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
    const url = `${this.url}/${id}`;
    return super.get(url, this.controladoresDeInstancia.listar);
  }

  async editarPelaKey(modelo, controlador) {
    this.controladoresDeInstancia.editar = this.selecionarControlador(controlador);
    const url = `${this.url}/editar-formulario`;
    const response = await super.patch(url, modelo, this.controladoresDeInstancia.editar);
    
    if (response.ok) {
      return;
    } else {
        const responseJson = await response.json()
        throw new Error(responseJson.message? responseJson.message : `HTTP ${response.status}`);
    }
  }

  async confirmarDados(id, controlador) {
    this.controladoresDeInstancia.confirmar = this.selecionarControlador(controlador);
    const url = `${this.url}/confirmar-dados`;
    const response = await super.patch(url, id, this.controladoresDeInstancia.confirmar);
    if (response.ok) {
      return;
    } else {
      throw new Error('HTTP ' + response.status);
    }
  }
}

export const formularioService = new FormularioService();
